import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { authButtonStyle } from '../constants/authStyles';
import { tl } from '../utils/inlineI18n';
import './ProfessionPanels.css';

// Eğitmen NPC'ler (sunucudaki professionTrainers ile aynı).
export const PROFESSION_TRAINER_NPCS = new Set(['Olta Ustası Deniz', 'Tohumcu Aylin', 'Kazmacı Rüzgar', 'Usta Celatin']);

const ICONS = { fishing: '🎣', farming: '🌾', mining: '⛏️', craft: '🔨' };
const NAMES_EN = { fishing: 'Fishing', farming: 'Farming', mining: 'Mining', craft: 'Crafting' };

let cache = null;
const loadProfessions = async (force = false) => {
  if (cache && !force) return cache;
  const res = await axios.get('/api/professions');
  if (res.data?.success) cache = res.data;
  return cache;
};

const skillName = (skill, data) => tl(data?.skills?.[skill]?.name || skill, NAMES_EN[skill] || skill);

/** Meslek ekranlarının üstünde ustalık seviyesini gösterir. */
export function ProfessionBadge({ skill }) {
  const [data, setData] = useState(cache);
  useEffect(() => {
    loadProfessions(true).then(setData).catch(() => {});
  }, []);
  const s = data?.skills?.[skill];
  if (!s) return null;
  return (
    <div className="profession-badge" title={tl('Meslek ustalığı', 'Profession mastery')}>
      <span>{ICONS[skill]} {skillName(skill, data)} {tl('Ustalığı', 'Mastery')}</span>
      <strong>{tl('Sv.', 'Lv.')} {s.level}/{data.maxLevel}</strong>
    </div>
  );
}

/** Eğitmen NPC'de meslek ustalığını geliştirme paneli. */
export function ProfessionTrainer({ npcName, onGoldChange }) {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  useEffect(() => {
    loadProfessions(true).then(setData).catch(() => {});
  }, []);

  const skill = data ? Object.keys(data.trainers || {}).find((k) => data.trainers[k] === npcName) : null;
  if (!skill) return null;
  const s = data.skills[skill];
  const maxed = s.level >= data.maxLevel;

  const train = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const res = await axios.post('/api/professions/train', { skill });
      setResult({ ok: !!res.data?.trained, text: res.data?.message || (res.data?.success ? '' : tl('Eğitim yapılamadı', 'Training failed')), error: !res.data?.success });
      setData(await loadProfessions(true));
      onGoldChange?.();
    } catch (e) {
      setResult({ ok: false, error: true, text: e.response?.data?.message || tl('Eğitim yapılamadı', 'Training failed') });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="profession-trainer">
      <h3>{ICONS[skill]} {skillName(skill, data)} {tl('Ustalığı', 'Mastery')}</h3>
      <div className="profession-trainer-level">
        <strong>{tl('Seviye', 'Level')} {s.level}/{data.maxLevel}</strong>
      </div>
      <div className="profession-trainer-bar"><span style={{ width: `${(s.level / data.maxLevel) * 100}%` }} /></div>
      <p className="profession-trainer-info">
        {tl(
          `Her eğitim ${Number(data.cost).toLocaleString('tr-TR')} yang. Günde 1 kez deneyebilirsin, %${data.successRate} ihtimalle seviye atlarsın.`,
          `Each training costs ${Number(data.cost).toLocaleString('en-US')} yang. Once per day, ${data.successRate}% chance to level up.`,
        )}
      </p>
      {result ? (
        <p className={`profession-trainer-result${result.ok ? ' profession-trainer-result--ok' : ''}${result.error ? ' profession-trainer-result--err' : ''}`}>{result.text}</p>
      ) : null}
      <button
        type="button"
        className="auth-button"
        style={authButtonStyle}
        disabled={busy || maxed || s.trainedToday}
        onClick={train}
      >
        {maxed
          ? tl('En üst seviye', 'Max level')
          : s.trainedToday
            ? tl('Bugün eğitim aldın, yarın gel', 'Come back tomorrow')
            : busy ? '…' : tl(`Eğit (${Number(data.cost).toLocaleString('tr-TR')} yang)`, `Train (${Number(data.cost).toLocaleString('en-US')} yang)`)}
      </button>
    </div>
  );
}
